import {
  canUseSponsorPrefill,
  createConfirmPrefill,
  prefillValue,
} from './shared';

export const getProfilePrefillRating = prefillValue('disabilityRating');
export const getProfilePrefillPermanentAndTotal =
  prefillValue('permanentAndTotal');

export const hasProfileRating = formData =>
  Number.isInteger(getProfilePrefillRating(formData));

// the read-only page needs the rating to show, and P&T must be a confirmed true
export const hasProfilePermanentAndTotalPrefill = formData =>
  getProfilePrefillPermanentAndTotal(formData) === true &&
  hasProfileRating(formData);

export const showSponsorDisabilityRating = formData =>
  canUseSponsorPrefill(formData) && hasProfileRating(formData);

export const showSponsorNotPermanentAndTotalWarning = formData =>
  canUseSponsorPrefill(formData) &&
  getProfilePrefillPermanentAndTotal(formData) === false;

// no confirm key: the page is read-only and sets the answer to Yes
export const {
  showPrefill: showSponsorDisabilityPrefill,
  showEntry: showSponsorDisabilityEntry,
  sync: syncSponsorDisabilityPrefill,
} = createConfirmPrefill({
  appliedKey: 'view:sponsorDisabilityPrefillApplied',
  hasPrefill: hasProfilePermanentAndTotalPrefill,
  fields: { 'view:sponsorIsDisabled': () => true },
});
